import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/data-center/")({
  beforeLoad: () => {
    throw redirect({ to: "/data-center/review" });
  },
});
